import React, { useEffect, useState } from "react";
import uploadArrow from "../../assets/images/upload-arrow.svg";
import pen from "../../assets/images/pen.svg";
import camera from "../../assets/images/camera.svg";
import Icon_L from "../../assets/images/Icon_L.svg";
import { useDispatch } from "react-redux";
import { setAccountOpeningStep } from "../../redux/accountOpening";
import { useFormik } from "formik";
import axios from "axios";
import * as toast from "../../utils/makeToast";
import { IBankBranch, Icurrency } from "../../models/IEnums.model";
import { baseUrl } from "../../utils/baseUrl";
import { getLocalStorageItem } from "../../utils/localStorage";
import closeIcon from "../../assets/images/close-icon.svg";
import Camera, { FACING_MODES, IMAGE_TYPES } from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import { trimImageURI } from "../../utils/imageUpload";
import SignatureCanvas from "react-signature-canvas";
import {
  links,
  MAX_FILE_UPLOAD_SIZE_FIGURE,
  MAX_FILE_UPLOAD_SIZE_TEXT,
} from "../../utils/constants";
import Select from "react-select";
import "youverify-web-sdk";
import DOMPurify from "dompurify";
import { encryptRequest } from "../../utils/encryption";
import CameraComponent from "../CameraComponent";
import { returnConfigVariable } from "../../utils/helpers";

function UploadDocumentJointCurrentDialog(props: any) {
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      branchOfDomiciliation: 0,
      smsAlertValueAddedService: "",
      emailAlertValueAddedService: "",
      debitCardValueAddedService: "",
      checkBookValueAddedService: "",
      accountCurrencies: "",
      terms: "",
      debitCardType: "master_card",
    },
    onSubmit: (values) => {
      uploadDcouments(values);
    },
  });

  const [bankBranches, setBankBranches] = useState<IBankBranch[]>([]);
  const [currencies, setCurrencies] = useState<Icurrency[]>([]);
  const [updating, setUpdating] = useState(false);

  const [selectedBranch, setSelectedBranch] = useState<any>();
  const [mappedBranches, setMappedBranches] = useState([]);

  const [signatureImageUrl, setSignatureImageUrl] = useState("");
  const [pictureImageUrl, setPictureImageUrl] = useState("");
  const [frontPageImageUrl, setFrontPageImageUrl] = useState("");

  const [settingSignatureImage, setSettingSignatureImage] =
    useState<boolean>(false);
  const [settingPictureImage, setSettingPictureImage] =
    useState<boolean>(false);
  const [settingFrontPageImage, setSettingFrontPageImage] =
    useState<boolean>(false);

  const [userDetails, setUserDetails] = useState(
    getLocalStorageItem("userDetails")
  );
  const [bvnValidationData, setBvnValidationData] = useState(
    getLocalStorageItem("bvnValidationData")
  );
  const [userExistingDetails, setUserExistingDetails] = useState<any>();

  const [showCamera, setShowCamera] = useState<boolean>(false);
  const [livePictureDocumentName, setLivePictureDocumentName] =
    useState<string>("");

  const [showSignaturePad, setShowSignaturePad] = useState<boolean>(false);
  const [signatureName, setSignatureName] = useState<string>("");

  const goToStep = (step: any) => {
    if (step === "update-detail") {
      localStorage.setItem("previous-screen", "document-upload");
    }
    dispatch(setAccountOpeningStep(step));
  };

  let fileUploadObj: any;

  const getBankBranches = () => {
    axios
      .get(`${baseUrl}Enum/BranchCodeList`)
      .then((response) => {
        setBankBranches(response.data);
        let tempBranches = response.data;
        tempBranches = response.data.map((branch: IBankBranch) => {
          return {
            label: branch.branch,
            value: branch.brancH_CODE,
          };
        });
        setMappedBranches(tempBranches);
      })
      .catch((err) => {
        
      });
  };

  const handleSelectBranch = (data: any) => {
    setSelectedBranch(data);
  };

  const getCurrencies = () => {
    axios
      .get(`${baseUrl}Enum/Currency`)
      .then((response) => {
        setCurrencies(response.data);
      })
      .catch((err) => {
        
      });
  };

  const getExistingDetails = () => {
    axios
      .get(
        `${baseUrl}JointCurrent/JointCurrentExistingDetails?Bvn=${encryptRequest(
          userDetails.bvn
        )}`
      )
      .then((response) => {
        
        setUserExistingDetails(response?.data);
      })
      .catch((err) => {
        
      });
  };

  const uploadDcouments = (values: any) => {
    let uploadDocumentPayload = {
      id: userExistingDetails?.id,
      uploadSignature: signatureImageUrl,
      uploadPicture: pictureImageUrl,
      frontPageId: frontPageImageUrl,
      // branchOfDomiciliation: +values.branchOfDomiciliation,
      branchOfDomiciliation: +selectedBranch?.value,
      // smsAlertValueAddedService: typeof values.smsAlertValueAddedService == 'boolean' ? values.smsAlertValueAddedService : false,
      // emailAlertValueAddedService: typeof values.emailAlertValueAddedService == 'boolean' ? values.emailAlertValueAddedService : false,
      smsAlertValueAddedService: true,
      emailAlertValueAddedService: true,
      debitCardValueAddedService:
        typeof values.debitCardValueAddedService == "boolean"
          ? !values.debitCardValueAddedService
          : true,
      checkBookValueAddedService:
        typeof values.checkBookValueAddedService == "boolean"
          ? values.checkBookValueAddedService
          : false,

      accountTypecode: localStorage.getItem("altFinanceGlCode"),
      accountTypeName: localStorage.getItem("altFinanceAccountType"),

      occupationName: "",
      isFlagged: bvnValidationData.isFlagged,
    };
    if (!uploadDocumentPayload.uploadSignature) {
      toast.errorToast("Please provide a signature");
      return;
    }
    if (!uploadDocumentPayload.uploadPicture) {
      toast.errorToast("Please provide a picture");
      return;
    }
    if (!uploadDocumentPayload.frontPageId) {
      toast.errorToast("Please provide front page of ID");
      return;
    }
    if (!uploadDocumentPayload.branchOfDomiciliation) {
      toast.errorToast("Please select a branch of account domiciliation");
      return;
    }
    if (!values.terms) {
      toast.errorToast("Please accept terms and conditions");
      return;
    }
    
    
    // return
    setUpdating(true);
    axios
      .post(
        `${baseUrl}CurrentAccount/CurrentDocumentUpload`,
        uploadDocumentPayload
      )
      .then((response) => {
        
        setUpdating(false);
        if (!response?.data?.isSuccess) {
          toast.errorToast(response?.data?.message);
          return;
        }
        localStorage.setItem(
          "generatedAccountNumber",
          response.data[0].accountNo
        );
        dispatch(setAccountOpeningStep("account-opening-success"));
      })
      .catch((err) => {
        
        setUpdating(false);
        toast.errorToast(
          err?.response?.data?.title
            ? err?.response?.data?.title
            : err?.response?.data?.message
        );
      });
  };

  useEffect(() => {
    getBankBranches();
    getCurrencies();
    getExistingDetails();
  }, []);

  const uploadImage = (payload: any, type: string) => {
    // return
    if (type === "signature") {
      setSettingSignatureImage(true);
    }
    if (type === "frontPageId") {
      setSettingFrontPageImage(true);
    }
    if (type === "image") {
      setSettingPictureImage(true);
    }
    axios
      .post(`${baseUrl}Authentication/UploadFile`, payload)
      .then((response) => {
        
        if (type == "signature") {
          
          setSignatureImageUrl(response.data?.id);
          setSettingSignatureImage(false);
        } else if (type == "frontPageId") {
          
          setFrontPageImageUrl(response.data?.id);
          setSettingFrontPageImage(false);
        } else if (type == "image") {
          
          setPictureImageUrl(response.data?.id);
          setSettingPictureImage(false);
        }
      })
      .catch((err) => {
        
        setSettingSignatureImage(false);
        setSettingFrontPageImage(false);
        setSettingPictureImage(false);
        toast.errorToast(
          err?.response?.data?.title
            ? err?.response?.data?.title
            : err?.response?.data?.message
        );
      });
  };

  const handleSubmit = (type: string) => {
    uploadImage(fileUploadObj, type);
  };

  const convertToBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        let fileReaderResult = fileReader.result?.toString();
        if (
          fileReader.result
            ?.toString()
            .substring(0, 25)
            .split("/")[1]
            .split(";")[0] === "png" ||
          fileReader.result
            ?.toString()
            .substring(0, 25)
            .split("/")[1]
            .split(";")[0] === "jpg" ||
          fileReader.result
            ?.toString()
            .substring(0, 25)
            .split("/")[1]
            .split(";")[0] === "pdf"
        ) {
          return resolve(fileReaderResult?.substring(22));
        } else if (
          fileReader.result
            ?.toString()
            .substring(0, 25)
            .split("/")[1]
            .split(";")[0] === "jpeg"
        ) {
          return resolve(fileReaderResult?.substring(23));
        } else {
          toast.errorToast(`Invalid file format`);
        }
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleFileUpload = async (e: any, type: string) => {
    const file = e.target.files[0];
    let fileSize = file.size / 1000;
    const allowedFileTypes = ["image/jpeg", "image/png", "application/pdf"];

    // Validate file type
    if (!allowedFileTypes.includes(file.type)) {
      

      toast.errorToast("Only image (JPEG, PNG) or PDF files are allowed.");
      return;
    }
    if (fileSize > MAX_FILE_UPLOAD_SIZE_FIGURE) {
      toast.errorToast(
        `File size should be less than ${MAX_FILE_UPLOAD_SIZE_TEXT}`
      );
      return;
    }
    let base64: any;

    convertToBase64(file).then((res) => {
      base64 = res;
      fileUploadObj = {
        postedFilebase64: res,
        documentName: type,
        filetype: file.type.split("/")[1],
      };
      handleSubmit(type);
    });
  };

  const clearImage = (type: any) => {
    if (type === "signature") {
      
      setSignatureImageUrl("");
    }
    if (type === "picture") {
      setPictureImageUrl("");
    }
    if (type === "frontPageId") {
      setFrontPageImageUrl("");
    }
  };

  const toggleCamera = (type: string, value: boolean) => {
    setLivePictureDocumentName(type);
    setShowCamera(value);
  };

  const handleTakePhoto = (dataUri: any) => {
    let res = trimImageURI(dataUri);
    fileUploadObj = {
      postedFilebase64: res,
      documentName: livePictureDocumentName,
      filetype: "png",
    };
    handleSubmit(livePictureDocumentName);
    setShowCamera(false);
  };

  const handleCameraError = (error: any) => {
    toast.errorToast("Something went wrong, please try again");
  };

  const handleCameraStart = () => {
    // 
  };

  const handleCameraStop = () => {
    // 
  };

  let sigPad: any = {};

  const toggleSignaturePad = (type: string, value: boolean) => {
    setSignatureName(type);
    setShowSignaturePad(value);
  };

  const closeSignaturePad = () => {
    clearSignaturePad();
    setShowSignaturePad(false);
  };

  const clearSignaturePad = () => {
    sigPad.clear();
  };

  const uploadSignaturePadSketch = () => {
    let res = trimImageURI(sigPad.getTrimmedCanvas().toDataURL("image/png"));
    fileUploadObj = {
      postedFilebase64: res,
      documentName: signatureName,
      filetype: "png",
    };
    handleSubmit(signatureName);
    closeSignaturePad();
  };

  const LivenessCheckClick = () => {
    // Initialize the Youverify Liveness Check module
    //@ts-ignore
    const YVSDK = window.YouverifySDK;
    
    const livenessCheckModule = new YVSDK.liveness({
      publicMerchantKey: returnConfigVariable('REACT_APP_YOUVERIFY_PUBLIC_MERCHANT_KEY'),
      dev: false,
      personalInformation: {
        firstName: `${userDetails.firstName}`,
      },
      appearance: {
        greeting:
          "We will need to perform a liveness test. It will only take a moment.",
        actionText: "Perform Liveness Test",
        buttonBackgroundColor: "#46B2C8",
        buttonTextColor: "#ffffff",
        primaryColor: "#46B2C8",
      },
      onSuccess: (data) => {
        
        
        toggleCamera("image", true);
        // Handle successful liveness check, e.g., update UI or send data to the server
      },
      onFailure: () => {
        

        // Handle liveness check failure
      },
      onClose: () => {
        

        // Handle modal closure
      },
    });

    try {
      // Initialize the Liveness Check module
      livenessCheckModule.initialize();

      // Start the liveness check process when the component mounts
      livenessCheckModule.start();
    } catch (error) {
      console.error("Error initializing Liveness Check:", error);
      // Handle initialization error
    }

    // Cleanup function to be called when the component unmounts
    return () => {
      // You can add cleanup logic here if needed
    };
  };

  return (
    <div>
      {showSignaturePad && (
        <div className="pt-4 pb-4 signature-pad-div">
          <p className="text-center">Draw your signature inside the box</p>
          <div className="signature-pad-inner-div">
            <SignatureCanvas
              penColor="black"
              ref={(ref) => {
                sigPad = ref;
              }}
              canvasProps={{ width: 300, height: 200, className: "sigCanvas" }}
            />
          </div>
          <div className="d-flex justify-content-center mt-4">
            <button
              className="signature-cancel-btn"
              onClick={closeSignaturePad}
            >
              Close
            </button>
            <button className="signature-clear-btn" onClick={clearSignaturePad}>
              Clear
            </button>
            <button
              className="signature-upload-btn"
              onClick={uploadSignaturePadSketch}
            >
              Upload
            </button>
          </div>
        </div>
      )}

      {showCamera && (
        <div style={{ overflowX: "scroll" }} className="pt-2">
          <CameraComponent
            onTakePhoto={(dataUri) => {
              handleTakePhoto(dataUri);
            }}
            onCameraError={(error) => {
              handleCameraError(error);
            }}
            idealFacingMode={FACING_MODES.ENVIRONMENT}
            idealResolution={{ width: 640, height: 480 }}
            imageType={IMAGE_TYPES.PNG}
            imageCompression={0.97}
            isMaxResolution={false}
            isImageMirror={false}
            isSilentMode={false}
            isDisplayStartCameraError={true}
            isFullscreen={false}
            sizeFactor={1}
            onCameraStop={() => {
              handleCameraStop();
            }}
            onCameraStart={() => {
              handleCameraStart();
            }}
          />
        </div>
      )}

      <form onSubmit={formik.handleSubmit}>
        <div className=" card-form pl-1 pr-1 ">
          <div className="card-body">
            <h4 className="card-title text-center pl-3 mt-5">
              Document upload
            </h4>
            <p className="text-center">
              <small>
                The file format should be JPEG, PNG or PDF (max size:2mb)
              </small>
            </p>

            <div className="row mr-3">
              {!signatureImageUrl ? (
                <React.Fragment>
                  <div className="col-sm-6 row">
                    <div className="col-sm-6">
                      <div className="col-md-6">
                        <label
                          htmlFor="firstname"
                          className="label_text2 d-inline text-nowrap"
                        >
                          Draw/Upload Signature
                        </label>
                        <br />
                        <label
                          className="cursor-pointer"
                          htmlFor="inputTagSignature"
                        >
                          <div className="pic_upload d-flex justify-content-between pt-3 pr-3 px-2">
                            {settingSignatureImage ? (
                              <div className="center-v">
                                <div
                                  className="spinner-border text-danger"
                                  role="status"
                                >
                                  <span className="sr-only"></span>
                                </div>
                              </div>
                            ) : (
                              <React.Fragment>
                                <p className="label_text">
                                  Click or drag <br /> and drop file
                                </p>
                                <img
                                  className="img-fluid"
                                  src={uploadArrow}
                                  alt=""
                                />
                              </React.Fragment>
                            )}
                          </div>
                          <input
                            onChange={(e) => handleFileUpload(e, "signature")}
                            id="inputTagSignature"
                            className="input-file-type"
                            type="file"
                            name="file"
                            accept="image/png, image/jpg, image/jpeg"
                          />
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="col-md-6 mt-4">
                        <div
                          className="pic_upload d-flex justify-content-between pt-3 pr-3 px-2"
                          onClick={() => toggleSignaturePad("signature", true)}
                        >
                          <p className="label_text">
                            Draw an <br /> e-signature
                          </p>
                          <img className="img-fluid" src={pen} alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                ""
              )}

              {signatureImageUrl ? (
                <div className="col-md-6">
                  <div className="img-upload-success-div">
                    <div className="close-icon-signature-div">
                      <div className="close-icon-img cursor-pointer">
                        <img
                          src={closeIcon}
                          onClick={() => clearImage("image")}
                        ></img>
                      </div>
                      <div className="signature-img-div">
                        {signatureImageUrl && (
                          <img
                            src={DOMPurify.sanitize(signatureImageUrl)}
                            width="70%"
                            height="120px"
                          ></img>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              {/* ------------------------ */}

              {!pictureImageUrl ? (
                <React.Fragment>
                  <div className="col-sm-6 row">
                    <div className="col-sm-6">
                      <div className="col-md-6">
                        <label
                          htmlFor="firstname"
                          className="label_text2 text-nowrap"
                        >
                          Take/Upload live picture
                        </label>
                        <br />
                        <label
                          className="cursor-pointer"
                          htmlFor="inputTagImage"
                        >
                          <div className="pic_upload d-flex justify-content-between pt-3 pr-3 px-2">
                            {settingPictureImage ? (
                              <div className="center-v">
                                <div
                                  className="spinner-border text-danger"
                                  role="status"
                                >
                                  <span className="sr-only"></span>
                                </div>
                              </div>
                            ) : (
                              <React.Fragment>
                                <p className="label_text">
                                  Click or drag <br /> and drop file
                                </p>
                                <img
                                  className="img-fluid"
                                  src={uploadArrow}
                                  alt=""
                                />
                              </React.Fragment>
                            )}
                          </div>
                          <input
                            onChange={(e) => handleFileUpload(e, "image")}
                            id="inputTagImage"
                            className="input-file-type"
                            type="file"
                            accept="image/png, image/jpg, image/jpeg"
                          />
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="col-md-6 mt-4">
                        {/* <div className="pic_upload d-flex justify-content-between pt-3 pr-3 px-2" onClick={() =>  toggleCamera('image', true)}> */}
                        <div
                          className="pic_upload d-flex justify-content-between pt-3 pr-3 px-2"
                          onClick={LivenessCheckClick}
                        >
                          <p className="label_text">
                            Take live
                            <br />
                            picture
                          </p>
                          <img className="img-fluid" src={camera} alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                ""
              )}

              {pictureImageUrl ? (
                <div className="col-md-6">
                  <div className="img-upload-success-div">
                    <div className="close-icon-signature-div">
                      <div className="close-icon-img cursor-pointer">
                        <img
                          src={closeIcon}
                          onClick={() => clearImage("picture")}
                        ></img>
                      </div>
                      <div className="signature-img-div">
                        {pictureImageUrl && (
                          <img
                            src={DOMPurify.sanitize(pictureImageUrl)}
                            width="70%"
                            height="120px"
                            style={{ zIndex: 1, margin: "auto" }}
                          ></img>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>

            <div className="row">
              {!frontPageImageUrl ? (
                <React.Fragment>
                  <div className="col-md-6">
                    <div className="col-md-6 mt-4">
                      <label
                        htmlFor="firstname"
                        className="label_text2 d-inline text-nowrap"
                      >
                        Front page of ID
                      </label>
                      <br />
                      <label
                        className="cursor-pointer"
                        htmlFor="inputTagFrontPageId"
                      >
                        <div className="pic_upload2 d-flex justify-content-between font-weight-bold pt-3 pr-3 px-2">
                          {settingFrontPageImage ? (
                            <div className="center-v">
                              <div
                                className="spinner-border text-danger"
                                role="status"
                              >
                                <span className="sr-only"></span>
                              </div>
                            </div>
                          ) : (
                            <React.Fragment>
                              <p className="label_text">
                                Click or drag <br /> and drop file
                              </p>
                              <img
                                className="img-fluid"
                                src={uploadArrow}
                                alt=""
                              />
                            </React.Fragment>
                          )}
                        </div>
                        <input
                          onChange={(e) => handleFileUpload(e, "frontPageId")}
                          id="inputTagFrontPageId"
                          className="input-file-type"
                          type="file"
                          accept="image/png, image/jpg, image/jpeg"
                        />
                      </label>
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                ""
              )}

              {frontPageImageUrl ? (
                <div className="col-md-6">
                  <div className="img-upload-success-div">
                    <div className="close-icon-signature-div">
                      <div className="close-icon-img cursor-pointer">
                        <img
                          src={closeIcon}
                          onClick={() => clearImage("frontPageId")}
                        ></img>
                      </div>
                      <div className="signature-img-div">
                        {frontPageImageUrl && (
                          <img
                            src={DOMPurify.sanitize(frontPageImageUrl)}
                            width="70%"
                            height="120px"
                            style={{ zIndex: 1, margin: "auto" }}
                          ></img>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>

            <div className="row mt-3 ml-1">
              <div className="col form-group">
                <label htmlFor="branch domicilation" className="label_text">
                  Branch of account domiciliation
                </label>
                <Select
                  options={mappedBranches}
                  value={selectedBranch}
                  onChange={handleSelectBranch}
                />
              </div>
            </div>
            <div className="row container mt-3 ml-1">
              <label htmlFor="branch domicilation" className="label_text mb-3">
                Select value-added services
              </label>

              <div className="custom-control custom-checkbox input-group mb-2">
                <input
                  name="smsAlertValueAddedService"
                  onChange={formik.handleChange}
                  value={formik.values.smsAlertValueAddedService}
                  type="checkbox"
                  className="custom-control-input"
                  id="checkbox1"
                  checked
                />
                <label
                  className="custom-control-label pl-3"
                  htmlFor="checkbox1"
                >
                  SMS alert
                </label>
              </div>
              <div className="custom-control custom-checkbox checkbox-lg border-dark input-group mb-2">
                <input
                  name="emailAlertValueAddedService"
                  onChange={formik.handleChange}
                  value={formik.values.emailAlertValueAddedService}
                  type="checkbox"
                  className="custom-control-input"
                  id="checkbox2"
                  checked
                />
                <label
                  className="custom-control-label pl-3"
                  htmlFor="checkbox2"
                >
                  Email alert
                </label>
              </div>
              <div className="custom-control custom-checkbox checkbox-lg input-group mb-2">
                <input
                  name="debitCardValueAddedService"
                  onChange={formik.handleChange}
                  value={formik.values.debitCardValueAddedService}
                  type="checkbox"
                  className="custom-control-input"
                  id="checkbox3"
                />
                <label
                  className="custom-control-label pl-3"
                  htmlFor="checkbox3"
                >
                  <b>
                    Debit card (Verve/Mastercard) - Click here, if you do not
                    want a debit card{" "}
                  </b>
                </label>
              </div>

              {!formik.values.debitCardValueAddedService && (
                <div className="row container" id="dvPassport">
                  <div className="col-md-3 form-group">
                    <div className="custom-control custom-radio input-group mb-2">
                      <input
                        name="debitCardType"
                        onChange={formik.handleChange}
                        value="verve"
                        type="radio"
                        className="custom-control-input debit-card-radio-input"
                        id="rad1"
                        checked={formik.values.debitCardType === "verve"}
                      />
                      <label
                        className="custom-control-label pl-3"
                        htmlFor="rad1"
                      >
                        Verve
                      </label>
                    </div>
                  </div>
                  <div className="col-md-4 mb-4">
                    <div className="custom-control custom-radio input-group mb-2">
                      <input
                        name="debitCardType"
                        onChange={formik.handleChange}
                        value="master_card"
                        type="radio"
                        className="custom-control-input debit-card-radio-input"
                        id="rad2"
                        checked={formik.values.debitCardType === "master_card"}
                      />
                      <label
                        className="custom-control-label pl-3"
                        htmlFor="rad2"
                      >
                        MasterCard
                      </label>
                    </div>
                  </div>
                  <div className="col-md-5 mt-n3">
                    <div className="bvn_val mb-2 " id="fader">
                      <img src={Icon_L} alt="" />
                      <small className="text-danger ml-3 text-nowrap">
                        . The card will be delivered to <br /> your residential
                        address
                      </small>
                    </div>
                  </div>
                </div>
              )}

              <div className="custom-control custom-checkbox checkbox-lg input-group mb-2">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="checkbox3"
                />
                <label
                  className="custom-control-label pl-3"
                  htmlFor="checkbox4"
                >
                  Survivorship clause
                </label>
              </div>
              <div className="custom-control custom-checkbox checkbox-lg input-group mb-2">
                <input
                  name="terms"
                  onChange={formik.handleChange}
                  value={formik.values.terms}
                  type="checkbox"
                  className="custom-control-input"
                  id="checkbox4"
                />
                <label
                  className="custom-control-label pl-3"
                  htmlFor="checkbox5"
                >
                  By checking this box, you have accepted the{" "}
                  <span>
                    <a
                      className="text-danger cursor-pointer"
                      href={links.termsAndConditionsPDF}
                      target="_blank"
                    >
                      <u>Terms and conditions</u>
                    </a>
                  </span>
                </label>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-2">
            <div className="mb-3 mr-4" style={{ marginRight: "20px" }}>
              <button
                onClick={() => {
                  goToStep("update-detail");
                }}
                className="btn btn-outline-danger mr-3 btn-filled-white"
              >
                Previous
              </button>
            </div>
            {updating ? (
              <div className="spinner-border text-danger" role="status">
                <span className="sr-only"></span>
              </div>
            ) : (
              <button type="submit" className="btn btn-danger btn-filled-red">
                Proceed
              </button>
            )}
          </div>
        </div>
      </form>
    </div>
  );
}

export default UploadDocumentJointCurrentDialog;
